export default __webpack_public_path__ + "images/title-slide-gradient.baaf778bfdebc7a5d4100ad87a4088aa.png";